










































import { Component, Vue } from 'vue-property-decorator'
import router from '@/router'
import VueRouter, { Route } from 'vue-router'
import store from '@/store'
import {getUser} from '@/store/userStore'
import menu from '@/router/menu'
import menuForShop from '@/router/menuForShop'
import menuCw1 from '@/router/menuCw1'
import menuKf1 from '@/router/menuKf1'
import menuKf2 from '@/router/menuKf2'
import menuKf3 from '@/router/menuKf3'
import menuKf4 from '@/router/menuKf4'
import menuKf5 from '@/router/menuKf5'
import menuJs1 from '@/router/menuJs1'
import menuSy from '@/router/menuSy'
import userMenus from '@/router/menuManage'

@Component
export default class Sidebar extends Vue {
  // private items = menu

  private get items() {

    return userMenus()
  }

  public created() {
    // 可以动态变更菜单，只需要动items即可
  }

  private get route() {
    return router.currentRoute
  }

  private get onRoutes() {
    return this.route.path
  }
  private get collapse() {
    return store.state.collapse
  }
}
